import Accounting from "./api/Accounting.api";
import Auth from "./api/Auth.api";
import User from "./api/User.api";
import Ticket from "./api/Ticket.api";
import Merchant from "./api/Merchant.api";
import Bootsale from "./api/Bootsale.api";
import Event from "./api/Event.api";
import Session from "./api/Session.api";
import Order from "./api/Order.api";
import Report from "./api/Report.api";
import Lagacy from "./api/Lagacy.api";
import Product from "./api/Product.api";
import Vote from "./api/Vote.api";
import AttendeeMessage from "./api/AttendeeMessage.api";
import Communication from "./api/Communication.api";

import Booth from "./api/Contest/Booth.api";
import Attendee from "./api/Contest/Attendee.api";
import Company from "./api/Contest/Company.api";
import Speaker from "./api/Contest/Speaker.api";
import Sponsor from "./api/Contest/Sponsor.api";
import Filter from "./api/Contest/Filter.api";
import LiveEvent from "./api/Contest/LiveEvent.api";
import VideoEvent from "./api/Contest/VideoEvent.api";
import LiveProduct from "./api/Contest/LiveProduct.api";
import Question from "./api/Question.api";
import Upsell from "./api/Upsell.api";
import Content from "./api/Contents.api";
import Video from "./api/Video";
import Speakers from "./api/Speaker";
import Tags from "./api/Tag";

import Font from "./api/Font.api";

export default {
  Accounting,
  Auth,
  Bootsale,
  User,
  Ticket,
  Merchant,
  Event,
  Session,
  Order,
  Report,
  Lagacy,
  Product,
  Vote,
  Company,
  Speaker,
  Sponsor,
  Filter,
  Booth,
  Attendee,
  LiveEvent,
  LiveProduct,
  Question,
  AttendeeMessage,
  Communication,
  Font,
  VideoEvent,
  Upsell,
  Content,
  Video,
  Tags,
  Speakers
};
